
export default{
    data: function () {
      return {
          shareNaverUrl:'http://share.naver.com/web/shareView.nhn',
          dropzone:null,
          detailDropzone:"",
          listDropzone:[],
          isKakaoInit:false
      }
    }
    , model:{
        prop:'detailDropzone'
        , event : 'listDrop'
    }
    , created: function () {
    }
    , mounted: function () {
       
   
    }
    , methods: {
      fnOnCreateNaverShareUrl:function(url, title, image){
        let _url = 'http://share.naver.com/web/shareView.nhn';
        _url += '?url=' + encodeURI(encodeURIComponent(url));
        _url += '&title=' + encodeURI(title);
        let _menubar = 'top=10, left=10, menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600';
        window.open(_url, '_blank', _menubar);
      }
      ,fnOnCreateFacebookShareUrl:function(url, title, image){
        let _url = 'http://www.facebook.com/sharer.php';
        _url += '?u=' + encodeURIComponent(url);
        let _menubar = 'top=10, left=10, menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600';
        window.open(_url, '_blank', _menubar);

      //   FB.ui({
      //           method: 'share',
      //           href: url
      //       }, function (response) {
      //           if (response && !response.error_code) {
      //               alert('공유 완료');
      //           } else {
      //               alert('공유 실패');
      //           }
      //       }
      //   );
      }
      , fnOnCreateKakaoShareUrl:function(urlLink, title, imageLink, description, videoLink, count, comment, share){
          Kakao.Link.sendDefault({
            objectType:'feed',
            content:{
              title : title,
              description : description, 
              imageUrl: imageLink,
              link: {
            	  mobileWebUrl: urlLink,
            	  webUrl: urlLink,
              },
            }
          });

          /*
          Kakao.Link.createDefaultButton({
            container: '#create-kakao-link-btn',
            objectType:'feed',
            content:{
              title : title,
              description : description, 
              imageUrl: imageLink,
              link: {
            	  mobileWebUrl: urlLink,
            	  webUrl: urlLink,
              },
          },
          // social: {
          //   likeCount: count,
          //   commentCount: comment,
          //   sharedCount: share,
          // },
          buttons: [
            {
              title: title,
              link: {
                mobileWebUrl: urlLink,
                webUrl: urlLink,
              },
            },
            // {
            //   title: title,
            //   link: {
            //     mobileWebUrl: urlLink,
            //     webUrl: urlLink,
            //   },
            // },
          ],
          });
          */
      }

    }
  }
